module.exports = __webpack_public_path__ + "static/img/z8.16aa1e1.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index1/z8.png
// module id = SjE/
// module chunks = 0